import {ProjectTimeTimelineDayContent} from "../timelineTypes";
import {htmlEscape} from "@/shared/utils/string";

/**
 * Component to display holiday information in a project time timeline day.
 * This component is used inside <code>ProjectTimeTimelineDay</code> to render holiday information for a specific day. If available, this component is appended to the day container.
 * For an overview of the timeline architecture, have a look into the UML diagram "timeline_web_components.png"
 */
export class ProjectTimeTimelineDayHoliday extends HTMLElement {
	private _timelineDay: ProjectTimeTimelineDayContent;

	set timelineDay(value: ProjectTimeTimelineDayContent) {
		this._timelineDay = value;
	}

	/**
	 * Main entry point to render the holiday information.
	 */
	public connectedCallback(): void {
		// timeline day (content) and holiday are required to render this component
		if (!this._timelineDay || !this._timelineDay.holiday) {
			return;
		}

		const {holiday} = this._timelineDay;
		const holidayElement = document.createElement("div");
		holidayElement.classList.add("timeline-holiday-entry");
		holidayElement.innerHTML = `
				<i class="fal fa-umbrella-beach position-left"></i>
				<span>${htmlEscape(holiday.description)}</span>
				`;
		this.append(holidayElement);
	}
}
